import { MouseEvent, ReactNode, useState } from 'react';

import { MenuList, Popover, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  popover: {
    zIndex: theme.zIndex.modal,
  },
}));

export type ContextMenuProps = {
  renderButton: (p: {
    id?: string;
    onClick: (event: MouseEvent<Element>) => void;
  }) => ReactNode;
  renderMenu: () => ReactNode;
  maxHeight?: string;
  id?: string;
};
export const ContextMenu = ({
  renderButton,
  renderMenu,
  maxHeight = 'auto',
  id,
}: ContextMenuProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (event: MouseEvent<Element>) => {
    if (anchorEl) {
      handleClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <>
      {renderButton({ onClick: handleToggle, id: `${id}-button` })}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        role={undefined}
        disablePortal
        className={classes.popover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          style: { maxHeight },
        }}
      >
        <MenuList
          disablePadding
          dense
          autoFocusItem={open}
          id={`${id}-dropdown`}
          onClick={handleClose}
        >
          {renderMenu()}
        </MenuList>
      </Popover>
    </>
  );
};
